import store from "@/store";
import axios from "axios";
import { getPathAPI, getAuthHeaders } from ".";

export async function deleteClaimsDocument(
  data: Record<string, any>
): Promise<void> {
  store.commit("claims/SET_STATES", { makingApiRequest: true });
  axios({
    url: `${getPathAPI()}/storage-forms`,
    method: "DELETE",
    data,
    headers: getAuthHeaders()
  }).finally(() => {
    store.commit("claims/SET_STATES", { makingApiRequest: false });
  });
}

export async function restoreClaimsDocument(
  data: Record<string, any>
): Promise<void> {
  store.commit("claims/SET_STATES", { makingApiRequest: true });
  axios({
    url: `${getPathAPI()}/storage-forms/restore`,
    method: "PUT",
    data,
    headers: getAuthHeaders()
  }).finally(() => {
    store.commit("claims/SET_STATES", { makingApiRequest: false });
  });
}
